import React from "react";

export function EstadoPptoTexto(props) {
    return (
        <span className="table-demo">
            <span className={`customer-badge status-ppto-${props.estado}`}>{props.estado === 1 ? "NORMAL" : "A PEDIDO"}</span>
        </span>
    );
}
